import React, { useMemo } from 'react'

import { useOptionalRestaurant } from 'src/shared/components/common/restaurant_context/RestaurantContext'

import { CTAData } from 'public/components/default_template/ctas'
import { MobileNavItems } from 'public/components/default_template/nav/NavItems'
import { getNavColorStyles } from 'public/components/default_template/nav/navUtils'

import LanguageIcon from './LanguageIcon'
import { LocaleSelectorModalContent } from './LocaleSelectorModal'
import { useSelectedLocale } from './common'

type MobileUserNavItemsProps = {
  onOpen: () => void
  onClose: () => void
  setModalContent: (content: JSX.Element) => void
  closeOverlay: () => void
  color?: string | null
}

export const MobileLocaleSelector = ({
  onOpen,
  onClose,
  setModalContent,
  closeOverlay,
  color
}: MobileUserNavItemsProps) => {
  const restaurant = useOptionalRestaurant()?.restaurant
  const modalContentStyle = getNavColorStyles(restaurant, false)
  const { selectedLocale } = useSelectedLocale()
  const localeSelectorCta = useMemo(
    (): CTAData[] => [
      {
        nav: true,
        text: selectedLocale?.label || '',
        type: 'customAction',
        onClick: () => {
          setModalContent(<LocaleSelectorModalContent onClose={onClose} />)
          onOpen()
        },
        icon: <LanguageIcon size={35} />
      }
    ],
    [onClose, onOpen, selectedLocale?.label, setModalContent]
  )

  if (!selectedLocale) {
    return null
  }

  return (
    <MobileNavItems
      ctas={localeSelectorCta}
      closeOverlay={closeOverlay}
      color={color || modalContentStyle.color}
    />
  )
}
